import { useMutation } from '@tanstack/react-query';
import { getExercisesPrint } from '../../../../queries/exercises';
import { usePrintComponentStore } from '../store/usePrintComponentStore';

export function useExercisePrintRequest() {
  const setExercises = usePrintComponentStore.getState().setData;

  const { mutate, isPending, isError } = useMutation({ 
    mutationKey: ['print-exercises-request'], 
    mutationFn: ({ subarea }: { subarea: string }) => getExercisesPrint(subarea),
    onSuccess: (response) => {
      setExercises(response);
    },
    retry: false
  });

  return { mutate, isPending, isError };
}
